<template lang="html">
	<div class="placed-backg about-page" id="page-info-t1">
		<div class="bg-image" v-bind:style="{ backgroundImage: 'url(public/images/pages/about-us/bg.jpg)' }"></div>

		<section class="container oversized-container content-section">
			<div class="row row-content align-items-center">
				<div class="col-lg-5 col-image"></div>

				<div class="col-lg-7 col-xl-6 col-info">
					<h1 class="mb-2 page-title">{{ 'about-us' | static-title }}</h1>

					<div class="text-justify static-content">
						{{ 'about-us' | static-content }}
					</div>
				</div>
			</div>
		</section>

	</div>
</template>

<script>
export default {
	data() {
		return {
			content: '',
		}
	},

	// methods: {
	//   getContent: function(){
	//     axios.get(tools.url('/historia')).then((response)=>{
	//       this.content = response.data;;
	//     }).catch((error)=>{
	//       console.log(error);
	//     })
	//   }
	// },

	// beforeMount(){
	//   this.getContent();
	// }
}
</script>
